module.exports = __webpack_public_path__ + "img/sadist_of_notre_dame_tablet.3cdbf35e.jpg";